export const commonEn = {
  // BEGIN Michael
  CREATE: 'Create',
  IMPORT: 'Import',
  EDIT: 'Edit',
  DELETE: 'Delete',
  VIEW: 'View',
  CANCEL: 'Cancel',
  HOME: 'Home',
  APPROVED: 'Approved',
  REQUEST: 'Request',
  REQUESTED: 'Requested',
  NOT_REQUESTED: 'Not Requested',
  DENIED: 'Denied',
  EMAIL_ADRESS: 'Email Address',
  BACKTO_LOGIN: 'Back to Login',
  STORY_BOOK: 'View Document',
  DEMO_TABLE_COMPONENT: 'Demo Table Component',
  PRIMARY_ACTION: 'Primary Action',
  SECONDARY_ACTION: 'Secondary Action',
  CONTROLLER_LIST: 'List of Controllers',
  INPUT_CONTROLLER: 'Input Field Controller',
  SINGLE_SELECT_CONTROLLER: 'Single Select Controller',
  CHECKBOX_CONTROLLER: 'Checkbox Controller',
  COMPONENTS: 'Components',
  YES: 'Yes',
  NO: 'No',
  NONE: 'None',
  NEW: 'New',
  APPLY: 'Apply',
  FILTER: 'Filter',
  DEFAULT: 'Default',
  ACTIONS: 'Actions',
  PREVIEW: 'Preview',
  ADD: 'Add',
  ROLE: 'Role',
  ROLES: 'Roles',
  YOU_DONT_HAVE_PERMISSION: 'You do not have permission to access this resource.',
  STATUS: {
    LABEL: 'Status',

    ALL: {
      TYPE_1: 'All',
      TYPE_2: 'All',
    },

    ACTIVE: {
      PLURAL: 'Active',
      SINGLE: 'Active',

      PLURAL_TYPE_2: 'Active',
      SINGLE_TYPE_2: 'Active',
    },

    INACTIVE: {
      PLURAL: 'Inactive',
      SINGLE: 'Inactive',

      PLURAL_TYPE_2: 'Inactive',
      SINGLE_TYPE_2: 'Inactive',
    },

    ACTIVATE: 'Activate',
    DESACTIVATE: 'Desactivate',
  },

  AMOUNT: 'Amount',
  CODE: 'Code',
  DATE_TIME: 'Date & Time',
  DOWNLOAD: 'Download',
  TOTAL_AMOUNT: 'Total Amount',
  SELECTED_AMOUNT: 'Selected Amount',

  ALL_OBJECTS: '{state} {object}',
  ACTIVE_OBJECTS: '{state} {object} ',
  INACTIVE_OBJECTS: '{state} {object} ',

  SESSION_HAS_TIMED_OUT: 'Session has timed out',
  PLEASE_RE_ENTER_YOUR_CREDENTIALS: 'Please re-enter your credentials to login again.',

  STRONG_PASSWORD: 'Password must contain',

  ERROR_BOUNDARY_HEADER: 'We ran into a problem.',
  ERROR_BOUNDARY_BODY: 'Try to refresh your browser or use your browser back button to go back to the previous page.',
  PAGE_404_TITLE: '404',
  PAGE_404_SUBHEADER: 'This page cannot be found',
  PAGE_404_MESSAGE: `The page you are looking for might have been removed,
        had its name changed, or is temporarily unavailable.`,

  PAGE_UNDER_CONSTRUCTION: 'Page Under Construction',
  PASSWORD: 'Password',
  R1VS_BASE_TITLE: 'R1vs Base UI backed by React and Ts',
  RECOVER_PASSWORD: 'Recover Password',
  NEW_PASSWORD: 'New Password',
  CONFIRM_PASSWORD: 'Confirm Password',
  RESET_PASSWORD: 'Reset Password',
  NOT_REGISTERED: 'Not registered?',
  WANT_TO_SEE_DEMO: 'want to see a demo?',

  USER_MANAGEMENT: {
    USER_CREATED_SUCCESSFULLY: 'User created successfully',
    USER_UPDATED_SUCCESSFULLY: 'User updated successfully',
    CHANGE_PASSWORD: {
      PASSWORD_NOT_MATCH: 'Password does not match',
      PASSWORD_CHANGED_SUCCESSFULLY: 'Password changed successfully',
      PASSWORD_PATTERN_FAILED:
        'Password must contain at least 8 characters, 1 uppercase, 1 lowercase, 1 number and 1 special character',
    },
    USER_ACTIVATE_CONFIRMATION: 'Are you sure you want to activate this user?',
    USER_DEACTIVATE_CONFIRMATION: 'Are you sure you want to deactivate this user?',
  },

  NUMBER_MUST_BE_GREATER_EQUALS_THAN: 'Number must be greater than or equal to {number}',
  NUMBER_MUST_BE_LESS_EQUALS_THAN: 'Number must be less than or equal to {number}',

  DATE_CANNON_BE_EARLIER_THAN: 'Date cannot be earlier than {date}',
  DATE_CANNON_BE_LATER_THAN: 'Date cannot be later than {date}',

  CURRENT_DATE: 'Current Date',
  ACCOUNT: 'Account',
  NICKNAME: 'Nickname',
  CONTACT_NAME: 'Contact Name',
  CONTACT_PHONE_NUMBER: 'Contact Phone Number',
  ADDITIONAL_INFO: 'Additional Info',
  ACCOUNT_NUMBER: 'Account Number',
  ACCOUNT_INFO: 'Account Info',
  PLEASE_ENTER_VALID_NUMBER: 'Please enter a valid number.',
  DAY: 'Day',
  DAYS: 'Days',
  ACH: 'ACH',
  CHECK: 'CHECK',
  EXPRESS_CODE: 'EXPRESS CODE',
  FUEL_CARD: 'FUEL CARD',
  SAME_DAY_ACH: 'SAME DAY ACH',
  WIRE: 'WIRE',
  CONTACT: 'Contact',
  JOB_TITLE: 'Job Title',
  EXT: 'Ext',
  ENABLED: 'Enabled',

  OPEN: {
    PLURAL: 'Open',
    PLURAL_2: 'Open',
    SINGLE: 'Open',
    SINGLE_2: 'Open',
  },

  CLOSE: {
    PLURAL: 'Closed',
    PLURAL_2: 'Closed',
    SINGLE: 'Closed',
    SINGLE_2: 'Closed',
    ACTION: 'Close',
  },
  PAGE_403_TITLE: '403',
  PAGE_403_SUBHEADER: 'Access Forbidden',
  PAGE_403_MESSAGE: `You don't have permission to access this resource`,
  TITLE: 'Title',
  DASHBOARD: 'Dashboard',
  // END Michael

  // BEGIN Fco
  CONTACTS: 'Contacts',
  SETTINGS: 'Settings',
  UPDATE: 'Update',
  SEARCH: 'Search',

  FUNDING: 'Funding',
  WS_ERROR: 'Something Went Wrong',
  INVALID_SESSION: 'Invalid Credentials',
  // END Fco

  // BEGIN Fabian
  NAME: 'Name',
  PHONE_NUMBER: 'Phone Number',
  FULL_NAME: 'Full Name',
  FIRST_NAME: 'First Name',
  MIDDLE_NAME: 'Middle Name',
  LAST_NAME: 'Last Name',
  EMAIL: 'Email',
  MAIL: 'Mail',
  ONLINE_PORTAL: 'Online Portal',
  CONFIRMATION_EMAIL: 'Confirmation Email',
  PHONE: 'Phone',
  REGISTRATION_SUCCESSFULLY: 'Thank you for registering!',
  REGISTRATION_SUCCESSFULLY_SUBTITLE: 'Please check your inbox for an email to set your password.',
  REGISTRATION_FAILURE_SUBTITLE: 'An error occurred during the registration process.',
  REGISTRATION_EMAIL_CONFIRMATION_FAILURE: 'Email Addresses do not match.',
  REGISTRATION_EMAIL_REGEX_FAILURE: 'Please enter a valid email.',
  REGISTRATION_REGEX_PHONE_FAILURE: 'Please enter a valid phone.',
  REGISTRATION_MIN_PHONE_LENGTH: 'Minimum length is 12',
  REGISTRATION_MAX_PHONE_LENGTH: 'Maximum length is 12',
  FAX: 'Fax',
  ADDRESS: {
    TYPE_1: 'Address',
    TYPE_2: 'Alternate Address',
  },
  COUNTRY: 'Country',
  CITY: 'City',
  STATE_CODE: 'State Code',
  ZIP: 'Zip Code',
  POSTAL_CODE: 'Postal Code',
  EIN: 'EIN',
  TYPE: 'Type',
  FACTOR_NAME: 'Factor Name',
  MAIN_ADDRESS: 'Main Address',
  ALTERNATIVE_ADDRESS: 'Alternative Address',
  COUNTRY_CODE: 'Country Code',
  ALTERNATIVE_PHONE_NUMBER: 'Alternative Phone Number',
  SUCCESSFULLY: 'Successfully!',
  ROWS: 'Rows',
  SELECTED: 'Selected',
  DETAILS: 'Details',
  INVALID_PHONE_NUMBER: 'Please enter a valid phone number',
  INVALID_ZIP_CODE: 'Please enter a valid zip code',
  INVALID_FAX_NUMBER: 'Please enter a valid fax number',
  MAX_LENGTH_ZIP_CODE: 'Maximum length is 10',
  INVALID_POSTAL_CODE: 'Please enter a valid postal code',
  MAX_LENGTH_POSTAL_CODE: 'The length must be 6',
  // END Fabian
  SEARCH_AND_FILTER: 'Search and Filter',
  NO_RESULTS: 'No Results Found!',
  ADJUST_SEARCH: "Try adjusting your search or filter to find what you're looking for.",
  NO_RECORDS: 'No records in the table',

  UNITED_STATES: 'United States',
  CANADA: 'Canada',
  MEXICO: 'Mexico',

  CHARCOUNT_MAX_LENGTH_MESSAGE: 'The text must be less than {value} characters',
  TEXT_MUST_BE_LESS_THAN: 'The text must be less than {number} characters',

  //BEGIN Patricio
  REJECT: {
    PLURAL: 'Rejected',
    SINGLE: 'Reject',
    ACTION: 'Reject',
  },
  NOT_RECORDS_FOUND: 'No records found',
  ROWS_PER_PAGE: 'Rows per page',
  RECORDS_ON_THIS_PAGE_ARE_SELECTED: 'Records on this page are selected',
  RECORDS_ARE_SELECTED: 'Records are selected',
  RECORDS_ACROSS_ALL_PAGES: 'Records across all pages',
  SELECT: 'Select',
  CLEAR_SELECTION: 'Clear Selection',
  CLEAR_FILTER: 'Clear Filters',
  //END Patricio
  //BEGIN Esteban
  LABEL: {
    PLURAL: 'Labels',
    SINGLE: 'Label',
  },
  OOS: 'OOS',
  INVALID_MC_NUMBER: 'Please enter a valid MC number (MC 12345678 or 12345678)',
  //END Esteban
}

export const commonEs: typeof commonEn = {
  // BEGIN Michael
  CREATE: 'Crear',
  IMPORT: 'Importar',
  EDIT: 'Editar',
  DELETE: 'Borrar',
  VIEW: 'Ver',
  CANCEL: 'Cancelar',
  HOME: 'Inicio',
  APPROVED: 'Aprobado',
  REQUEST: 'Solicitar',
  REQUESTED: 'Solicitado',
  NOT_REQUESTED: 'No Solicitado',
  DENIED: 'Denegado',
  EMAIL_ADRESS: 'Dirección de Correo Electrónico',
  BACKTO_LOGIN: 'Volver al Inicio de Sesión',
  STORY_BOOK: 'Ver Documento',
  DEMO_TABLE_COMPONENT: 'Demo Componente Tabla',
  PRIMARY_ACTION: 'Acción Primaria',
  SECONDARY_ACTION: 'Acción Secundaria',
  CONTROLLER_LIST: 'Lista de Controladores',
  INPUT_CONTROLLER: 'Controlador de Campo de Entrada',
  SINGLE_SELECT_CONTROLLER: 'Controlador de Selección Única',
  CHECKBOX_CONTROLLER: 'Controlador de Casilla de Verificación',
  COMPONENTS: 'Componentes',
  YES: 'Si',
  NO: 'No',
  NONE: 'Ninguno',
  NEW: 'Nuevo',
  APPLY: 'Aplicar',
  FILTER: 'Filtrar',
  DEFAULT: 'Por Defecto',
  ACTIONS: 'Acciones',
  PREVIEW: 'Vista Previa',
  ADD: 'Agregar',
  ROLE: 'Rol',
  ROLES: 'Roles',
  YOU_DONT_HAVE_PERMISSION: 'No tiene permiso para acceder a este recurso.',
  STATUS: {
    LABEL: 'Estado',

    ALL: {
      TYPE_1: 'Todos',
      TYPE_2: 'Todas',
    },

    ACTIVE: {
      PLURAL: 'Activos',
      SINGLE: 'Activo',

      PLURAL_TYPE_2: 'Activas',
      SINGLE_TYPE_2: 'Activa',
    },

    INACTIVE: {
      PLURAL: 'Inactivos',
      SINGLE: 'Inactivo',

      PLURAL_TYPE_2: 'Inactivas',
      SINGLE_TYPE_2: 'Inactiva',
    },

    ACTIVATE: 'Activar',
    DESACTIVATE: 'Desactivar',
  },

  AMOUNT: 'Monto',
  CODE: 'Código',
  DATE_TIME: 'Fecha y Hora',
  DOWNLOAD: 'Descargar',
  TOTAL_AMOUNT: 'Monto Total',
  SELECTED_AMOUNT: 'Monto Seleccionado',

  ALL_OBJECTS: '{state} {link} {object}',
  ACTIVE_OBJECTS: '{object} {state}',
  INACTIVE_OBJECTS: '{object} {state}',

  SESSION_HAS_TIMED_OUT: 'La sesión ha expirado',
  PLEASE_RE_ENTER_YOUR_CREDENTIALS: 'Ingrese nuevamente sus credenciales para iniciar sesión nuevamente.',

  STRONG_PASSWORD: 'La contraseña debe contener',

  ERROR_BOUNDARY_HEADER: 'Nos encontramos con un problema.',
  ERROR_BOUNDARY_BODY:
    'Intente actualizar su navegador o use el botón de retroceso de su navegador para volver a la página anterior.',
  PAGE_404_TITLE: '404',
  PAGE_404_SUBHEADER: 'Esta página no se puede encontrar',
  PAGE_404_MESSAGE: `Es posible que la página que está buscando se haya eliminado,
        cambiado su nombre o no esté disponible temporalmente.`,

  PAGE_UNDER_CONSTRUCTION: 'Página en Construcción',

  PASSWORD: 'Contraseña',
  R1VS_BASE_TITLE: 'R1vs Base UI respaldado por React y Ts',

  RECOVER_PASSWORD: 'Recuperar Contraseña',
  NEW_PASSWORD: 'Nueva Contraseña',
  CONFIRM_PASSWORD: 'Confirmar Contraseña',
  RESET_PASSWORD: 'Restablecer Contraseña',

  NOT_REGISTERED: '¿No está registrado?',
  WANT_TO_SEE_DEMO: '¿Quieres ver una demostración?',

  USER_MANAGEMENT: {
    USER_CREATED_SUCCESSFULLY: 'Usuario creado exitosamente',
    USER_UPDATED_SUCCESSFULLY: 'Usuario actualizado exitosamente',
    CHANGE_PASSWORD: {
      PASSWORD_NOT_MATCH: 'La contraseña no coincide',
      PASSWORD_CHANGED_SUCCESSFULLY: 'Contraseña cambiada exitosamente',
      PASSWORD_PATTERN_FAILED:
        'La contraseña debe contener al menos 8 caracteres, 1 mayúscula, 1 minúscula, 1 número y 1 carácter especial',
    },
    USER_ACTIVATE_CONFIRMATION: '¿Está seguro de que desea activar este usuario?',
    USER_DEACTIVATE_CONFIRMATION: '¿Está seguro de que desea desactivar este usuario?',
  },
  NUMBER_MUST_BE_GREATER_EQUALS_THAN: 'El número debe ser mayor o igual que {number}',
  NUMBER_MUST_BE_LESS_EQUALS_THAN: 'El número debe ser menor o igual que {number}',

  DATE_CANNON_BE_EARLIER_THAN: 'La fecha no puede ser anterior a {date}',
  DATE_CANNON_BE_LATER_THAN: 'La fecha no puede ser posterior a {date}',

  CURRENT_DATE: 'Fecha Actual',
  ACCOUNT: 'Cuenta',
  NICKNAME: 'Apodo',
  CONTACT_NAME: 'Nombre de Contacto',
  CONTACT_PHONE_NUMBER: 'Número de Teléfono de Contacto',
  ADDITIONAL_INFO: 'Información Adicional',
  ACCOUNT_NUMBER: 'Account Number',
  ACCOUNT_INFO: 'Información de la Cuenta',
  PLEASE_ENTER_VALID_NUMBER: 'Por favor, ingrese un número válido.',
  DAY: 'Día',
  DAYS: 'Días',
  ACH: 'ACH',
  CHECK: 'CHECK',
  EXPRESS_CODE: 'EXPRESS CODE',
  FUEL_CARD: 'FUEL CARD',
  SAME_DAY_ACH: 'SAME DAY ACH',
  WIRE: 'WIRE',
  CONTACT: 'Contacto',
  JOB_TITLE: 'Título del Trabajo',
  EXT: 'Ext',
  ENABLED: 'Habilitado',

  OPEN: {
    PLURAL: 'Abiertos',
    PLURAL_2: 'Abiertas',
    SINGLE: 'Abierto',
    SINGLE_2: 'Abierta',
  },

  CLOSE: {
    PLURAL: 'Cerrados',
    PLURAL_2: 'Cerradas',
    SINGLE: 'Cerrado',
    SINGLE_2: 'Cerrada',
    ACTION: 'Cerrar',
  },
  PAGE_403_TITLE: '403',
  PAGE_403_SUBHEADER: 'Acceso Prohibido',
  PAGE_403_MESSAGE: `No tiene permiso para acceder a este recurso`,
  TITLE: 'Título',
  DASHBOARD: 'Tablero',
  // END Michael

  // BEGIN Fco
  CONTACTS: 'Contactos',
  SETTINGS: 'Configuración',
  UPDATE: 'Actualizar',
  SEARCH: 'Buscar',

  FUNDING: 'Financiamiento',
  WS_ERROR: 'Ocurrio un error inesperado',
  INVALID_SESSION: 'Credenciales Inválidas',
  // END Fco

  // BEGIN Fabian
  NAME: 'Nombre',
  PHONE_NUMBER: 'Número de Teléfono',
  FULL_NAME: 'Nombre Completo',
  FIRST_NAME: 'Nombre',
  MIDDLE_NAME: 'Segundo Nombre',
  LAST_NAME: 'Apellido',
  EMAIL: 'Correo Electrónico',
  MAIL: 'Correo',
  ONLINE_PORTAL: 'Portal en Línea',
  CONFIRMATION_EMAIL: 'Confirmación de Correo Electrónico',
  PHONE: 'Teléfono',
  REGISTRATION_SUCCESSFULLY: '¡Gracias por registrarse!',
  REGISTRATION_SUCCESSFULLY_SUBTITLE: 'Por favor revise su correo electrónico para establecer su contraseña.',
  REGISTRATION_FAILURE_SUBTITLE: 'Ocurrió un error durante el proceso de registro.',
  REGISTRATION_EMAIL_CONFIRMATION_FAILURE: 'Las direcciones de correo electrónico no coinciden.',
  REGISTRATION_EMAIL_REGEX_FAILURE: 'Por favor ingrese un correo electrónico válido.',
  REGISTRATION_REGEX_PHONE_FAILURE: 'Por favor ingrese un teléfono válido.',
  REGISTRATION_MIN_PHONE_LENGTH: 'La longitud mínima es 12',
  REGISTRATION_MAX_PHONE_LENGTH: 'La longitud máxima es 12',
  FAX: 'Fax',
  ADDRESS: {
    TYPE_1: 'Dirección',
    TYPE_2: 'Dirección Alternativa',
  },
  COUNTRY: 'País',
  CITY: 'Ciudad',
  STATE_CODE: 'Código de Estado',
  ZIP: 'Código Postal',
  POSTAL_CODE: 'Código Postal',
  EIN: 'EIN',
  TYPE: 'Tipo',
  FACTOR_NAME: 'Nombre del Factor',
  MAIN_ADDRESS: 'Dirección Principal',
  ALTERNATIVE_ADDRESS: 'Dirección Alternativa',
  COUNTRY_CODE: 'Código de País',
  ALTERNATIVE_PHONE_NUMBER: 'Número de Teléfono Alternativo',
  SUCCESSFULLY: 'Exitosamente!',
  ROWS: 'Filas',
  SELECTED: 'seleccionada(s)',
  DETAILS: 'Detalles',
  INVALID_PHONE_NUMBER: 'Por favor ingrese un número de teléfono válido',
  INVALID_ZIP_CODE: 'Por favor ingrese un código postal válido',
  INVALID_FAX_NUMBER: 'Por favor ingrese un número de fax válido',
  MAX_LENGTH_ZIP_CODE: 'La longitud máxima es 10',
  MAX_LENGTH_POSTAL_CODE: 'La longitud debe ser 6',
  INVALID_POSTAL_CODE: 'Por favor ingrese un código postal válido',
  // END Fabian
  SEARCH_AND_FILTER: 'Search and Filter',
  NO_RESULTS: '¡No se han encontrado resultados!',
  ADJUST_SEARCH: 'Intente ajustar su búsqueda o filtro para encontrar lo que está buscando.',
  NO_RECORDS: 'No hay registros en la tabla',

  UNITED_STATES: 'Estados Unidos',
  CANADA: 'Canadá',
  MEXICO: 'México',

  CHARCOUNT_MAX_LENGTH_MESSAGE: 'El texto debe ser menor a {value} caracteres',
  TEXT_MUST_BE_LESS_THAN: 'El texto debe ser menor a {number} caracteres',

  //BEGIN Patricio
  REJECT: {
    PLURAL: 'Rechazados',
    SINGLE: 'Rechazado',
    ACTION: 'Rechazar',
  },
  NOT_RECORDS_FOUND: 'No se encontraron registros',
  ROWS_PER_PAGE: 'Filas por página',
  RECORDS_ON_THIS_PAGE_ARE_SELECTED: 'Registros en esta página están seleccionados',
  RECORDS_ARE_SELECTED: 'Registros están seleccionados',
  RECORDS_ACROSS_ALL_PAGES: 'Registros de todas las páginas',
  SELECT: 'Seleccionar',
  CLEAR_SELECTION: 'Limpiar Selección',
  CLEAR_FILTER: 'Limpiar Filtros',
  //END Patricio
  //BEGIN Esteban
  LABEL: {
    PLURAL: 'Labels',
    SINGLE: 'Label',
  },
  OOS: 'OOS',
  INVALID_MC_NUMBER: 'Por favor ingrese un número de MC válido (MC 123456)',
  //END Esteban
}
